export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: "Qu'est-ce que Pilates Reformer Prêt™️ exactement ?",
    answer:
      'Une collection de 6 niveaux progressifs de contenu pour professeurs de Pilates Reformer, avec vocabulaire technique, repères visuels, script de coaching et exercices classés par difficulté, plus 5 bonus de gestion de studio.',
  },
  {
    question: "Ai-je besoin d'un abonnement pour utiliser ce système ?",
    answer: 'Non. C’est un paiement unique avec accès à vie, y compris les futures mises à jour de la collection.',
  },
  {
    question: 'Ce contenu convient-il à un professeur qui débute sur le Reformer ?',
    answer:
      'Le Niveau 1 est conçu comme un point de départ accessible ; la progression jusqu’au Niveau 6 permet de suivre l’évolution de vos élèves sur plusieurs années.',
  },
  {
    question: "Le format est-il adapté à l'impression ?",
    answer:
      'Oui, chaque page est conçue pour être imprimée ou consultée directement depuis une tablette en studio.',
  },
  {
    question: 'Puis-je utiliser ce contenu pour des cours particuliers et des cours en petit groupe ?',
    answer: "Oui, le Bonus Planificateur inclut des variantes pour les deux formats d'enseignement.",
  },
  {
    question: 'Que se passe-t-il si le contenu ne me convient pas ?',
    answer: 'Vous disposez de 30 jours pour demander un remboursement complet, sans justification compliquée.',
  },
  {
    question: "Comment est-ce que je reçois le matériel après l'achat ?",
    answer: 'L’accès est immédiat après le paiement, par téléchargement direct depuis votre espace client.',
  },
]
